import React, { useState, useEffect, useCallback } from "react";
import { Col, Row, Pagination, Collapse, Button, Modal, message } from "antd";
import axios from "axios";
import {
  CaretRightOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import PageHeader from "../Layout/PageHeader";
import BeneficiaryRequestList from "./BeneficiaryRequestList";
import BeneficiaryRequestFilters from "./BeneficiaryRequestFilters";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

import DragUpload from "../Form/DragUpload";

import RemittanceButton from "../Remittance/RemittanceButton";
const BeneficiaryRequest = () => {
  const [loading, setLoading] = useState({ index: false });
  const [isDownloading, setIsDownloading] = useState(false);
  const [requests, setRequests] = useState();
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 50 });
  const [selectedRows, setSelectedRows] = useState([]);

  const { permissions } = usePermissions();

  const [bulkUpdateMerchant, setBulkUpdateMerchant] = useState();

  const fetchRequests = useCallback(async () => {
    setLoading((prevLoading) => ({ ...prevLoading, index: true }));

    const params = {
      limit: pagination.limit,
      page: pagination.currentPage,
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
      ...(filters.status !== null && { status: filters.status }),
      ...(filters.search && { search: filters.search, searchField: filters.searchField }),
    };
    const res = await axios.get("/api/beneficiary-requests", { params });

    setRequests(res.data.data || []);
    setPagination(res.data.pagination);
    setLoading((prevLoading) => ({ ...prevLoading, index: false }));
  }, [pagination.currentPage, pagination.limit, filters]);

  const downloadCSV = async () => {
    setIsDownloading(true);

    const messageContent = (
      <p>
        Are you sure you want to download {pagination?.totalSize} Beneficiary
        Request data ?<br />
      </p>
    );

    const params = {
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
      ...(filters.status !== null && { status: filters.status }),
      ...(filters.search && { search: filters.search, searchField: filters.searchField }),
    };

    Modal.confirm({
      content: messageContent,
      title: `Download Beneficiary Request List ? `,
      async onOk() {
        await axios
          .get("/api/beneficiary-requests/csv", { params })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });

    setIsDownloading(false);
  };

  useEffect(() => {
    fetchRequests();
  }, [pagination.currentPage, pagination.limit, fetchRequests]);

  return (
    <div>
      <PageHeader
        title="Beneficiary Request"
        childRoutes={[
          {
            path: "/beneficiary-request",
            breadcrumbName: "Beneficiary Request",
          },
        ]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <BeneficiaryRequestFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row className="mt-2 mb-2" justify="space-between">
        <div>
          <Button onClick={downloadCSV} loading={isDownloading}>
            CSV <DownloadOutlined />
          </Button>
        </div>
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>

      <BeneficiaryRequestList
        requests={requests}
        loading={loading.index}
        filters={setFilters}
        onUpdate={fetchRequests}
      />

      <Pagination
        total={pagination?.totalSize}
        pageSize={pagination?.limit}
        onChange={(currentPage, limit) => {
          setPagination({ ...pagination, limit, currentPage });
        }}
        current={pagination.currentPage}
      />
    </div>
  );
};

export default BeneficiaryRequest;
